import { __assign } from "tslib";
import { createFakePostResponder, createFakeGetResponder, createFakePutResponder, createFakeDeleteResponder } from '../test-utils';
import { createHttpTestKit } from '../http/test-kit';
import { createSimpleCustomFieldsApi, createMultilevelCustomFieldsApi, createMultiLingualCustomFieldsApi } from '.';
export var createSimpleCustomFieldsApiTestKitHandler = function (baseUrl, fakeHttp) {
    var testKit = {
        whenGetCustomFields: function () { return createFakeGetResponder(fakeHttp, baseUrl + "/fields"); },
        whenGetCustomField: function (id) { return createFakeGetResponder(fakeHttp, baseUrl + "/fields/" + id); },
        whenAdminGetCustomFields: function () { return createFakeGetResponder(fakeHttp, baseUrl + "/fields/admin"); },
        whenAdminGetCustomField: function (id) { return createFakeGetResponder(fakeHttp, baseUrl + "/fields/" + id + "/admin"); },
        whenAddCustomField: createFakePostResponder(fakeHttp, baseUrl + "/fields"),
        whenUpdateCustomField: function (dto) {
            return createFakePutResponder(fakeHttp, dto !== '*' ? baseUrl + "/fields/" + dto.id : dto)(dto);
        },
        whenDeleteCustomField: function (id) { return createFakeDeleteResponder(fakeHttp, baseUrl + "/fields/" + id); }
    };
    return testKit;
};
export var createSimpleCustomFieldsApiTestKit = function (baseUrl, itemType) {
    var fakeHttp = createHttpTestKit();
    var api = createSimpleCustomFieldsApi(baseUrl, fakeHttp, itemType);
    var testKit = createSimpleCustomFieldsApiTestKitHandler(baseUrl, fakeHttp);
    return __assign(__assign({}, api), testKit);
};
export var createMultiLingualCustomFieldsApiTestKitHandler = function (baseUrl, fakeHttp) {
    var testKit = {
        whenGetCustomFields: function () { return createFakeGetResponder(fakeHttp, baseUrl + "/fields"); },
        whenGetCustomField: function (id) { return createFakeGetResponder(fakeHttp, baseUrl + "/fields/" + id); },
        whenAdminGetCustomFields: function () { return createFakeGetResponder(fakeHttp, baseUrl + "/fields/admin"); },
        whenAdminGetCustomField: function (id) { return createFakeGetResponder(fakeHttp, baseUrl + "/fields/" + id + "/admin"); },
        whenAddCustomField: createFakePostResponder(fakeHttp, baseUrl + "/fields"),
        whenUpdateCustomField: function (dto) {
            return createFakePutResponder(fakeHttp, baseUrl + "/fields/" + dto.id)(dto);
        },
        whenDeleteCustomField: function (dto) { return createFakeDeleteResponder(fakeHttp, "/" + baseUrl + "/fields/" + dto.id); }
    };
    return testKit;
};
export var createMultiLingualCustomFieldsApiTestKit = function (baseUrl, itemType) {
    var fakeHttp = createHttpTestKit();
    var api = createMultiLingualCustomFieldsApi(baseUrl, fakeHttp, itemType);
    var testKit = createMultiLingualCustomFieldsApiTestKitHandler(baseUrl, fakeHttp);
    return __assign(__assign({}, api), testKit);
};
export var createMultilevelCustomFieldsApiTestKitHandler = function (baseUrl, fakeHttp) {
    var testKit = {
        whenAddMultilevelCustomField: createFakePostResponder(fakeHttp, baseUrl + "/multiLevelField"),
        whenUpdateMultilevelCustomField: function (dto) {
            return createFakePutResponder(fakeHttp, baseUrl + "/multiLevelField/" + dto.id)(dto);
        },
    };
    return testKit;
};
export var createMultilevelCustomFieldsApiTestKit = function (baseUrl, itemType) {
    var fakeHttp = createHttpTestKit();
    var api = createMultilevelCustomFieldsApi(baseUrl, fakeHttp, itemType);
    var testKit = createMultilevelCustomFieldsApiTestKitHandler(baseUrl, fakeHttp);
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map